import makeForm from '../../../components/Form';
import { OperacoesService } from '../../../services';
import Yup from '../../../utils/yup';
import { OperacaoFormValues } from '../types';

export const validationSchema = Yup.object().shape({
  descricao: Yup.string().required(),
  statusOperacao: Yup.string().required(),
  grupoMaquinas: Yup.array().min(1, 'Selecione ao menos um grupo de máquinas'),
  grupoInsumos: Yup.array().min(1, 'Selecione ao menos um grupo de insumos'),
  clienteAgrogestao: Yup.boolean().nullable(),
});

export const tiposFilter = OperacoesService.STATUS_OPERACOES.map(
  (statusOperacao) => ({
    id: statusOperacao,
    value: statusOperacao,
    label: OperacoesService.STATUS_OPERACOES_HUMANIZED[statusOperacao],
  }),
);

export const defaultValues: OperacaoFormValues = {
  descricao: '',
  statusOperacao: tiposFilter[0].value,
  grupoMaquinas: [],
  grupoInsumos: [],
  clienteAgrogestao: false,
};

export const OperacaoForm = makeForm<OperacaoFormValues>();
